




























































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import ItemData from 'src/assets/ItemData'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import AttendeeResponse from 'components/presenter/item/session/AttendeeResponse.vue'
import { Item, ItemTypeTopic, Session, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar,
    DialogFullscreen,
    AttendeeResponse
  }
})
export default class SessionManagerAttendeesListItem extends Vue {

  @Prop()
  readonly topic!: Item

  @Prop()
  readonly session!: Session

  @Prop()
  readonly attendee!: SessionAttendee

  @Prop()
  readonly currSlide!: Json

  @Ref()
  readonly dialog!: DialogFullscreen

  get contactName () {
    return this.attendee.publicProfile ? this.attendee.contactName : this.$t('attendee.guest.label').toString()
  }

  get attendeeResponseResult () {
    return this.attendee.data.responseResult
  }

  get percent () {
    return this.attendeeResponseResult.points * 100 / Math.max(1, this.attendeeResponseResult.pointsMax)
  }
}
